import React from "react";
import "./StaticPage.css";

export default function ShippingPolicy() {
  return (
    <div className="static-page">
      <div className="static-container">
        <span className="section-label">Legal</span>
        <h1>Shipping Policy</h1>
        <p className="static-intro">
          We ship authentic Pahadi products from the hills of Uttarakhand to your doorstep across India.
          Here's everything you need to know about how we deliver. Last updated: July 2026.
        </p>

        <section>
          <h2>Where We Ship</h2>
          <p>
            We deliver pan-India through Shiprocket and trusted courier partners like Delhivery. If your
            pincode is serviceable, you'll be able to place an order and see an estimated delivery date at checkout.
          </p>
        </section>

        <section>
          <h2>Delivery Timelines</h2>
          <ul>
            <li><strong>Metro cities:</strong> 3–5 business days.</li>
            <li><strong>Other locations:</strong> 4–7 business days.</li>
            <li><strong>Remote areas &amp; North-East:</strong> 7–10 business days.</li>
          </ul>
          <p>
            These are estimates. Actual delivery may vary due to weather, festivals, courier delays, or other
            factors beyond our control. You'll receive an estimated delivery date at checkout based on your pincode.
          </p>
        </section>

        <section>
          <h2>Order Processing</h2>
          <p>
            Orders are typically processed and dispatched within 1–2 business days of confirmation. Orders placed
            on Sundays or public holidays are processed the next working day.
          </p>
        </section>

        <section>
          <h2>Shipping Charges</h2>
          <p>
            Shipping charges (if any) are calculated at checkout based on your location and order weight.
            Cash on Delivery orders carry an additional ₹49 handling fee.
          </p>
        </section>

        <section>
          <h2>Tracking Your Order</h2>
          <p>
            Once your order ships, you'll receive an email with your AWB (tracking number) and a tracking link.
            You can also track your order anytime from the <a href="/orders">My Orders</a> page in your account.
          </p>
        </section>

        <section>
          <h2>Delivery Issues</h2>
          <ul>
            <li>Please ensure your delivery address and phone number are accurate at checkout.</li>
            <li>If a delivery fails due to an incorrect address or unavailability, re-delivery may incur additional charges.</li>
            <li>If your order arrives damaged, please take photos and contact us within 2 days — see our Return &amp; Refund Policy.</li>
          </ul>
        </section>

        <section>
          <h2>Need Help?</h2>
          <p>
            For any shipping-related questions, email us at <a href="mailto:wecare@purejar.in">wecare@purejar.in</a> with
            your Order ID, or message us on <a href="https://wa.me/918750128338" target="_blank" rel="noopener noreferrer">WhatsApp</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
